import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useFormatPaymentMethodSummary`

export default defineMessages({
  externalLabel: {
    id: `${scope}.externalLabel`,
    defaultMessage: 'External',
  },
  otherLabel: {
    id: `${scope}.otherLabel`,
    defaultMessage: 'Other',
  },
  achLabel: {
    id: `${scope}.achLabel`,
    defaultMessage: 'ACH',
  },
  eftLabel: {
    id: `${scope}.eftLabel`,
    defaultMessage: 'EFT',
  },
  wireLabel: {
    id: `${scope}.wireLabel`,
    defaultMessage: 'Wire',
  },
  checkLabel: {
    id: `${scope}.checkLabel`,
    defaultMessage: 'Check',
  },
})
